<ion-item
  class="ion-align-items-start"
  lines="none"
>
  <bl-avatar
    [user]="author"
    [size]="40"
  ></bl-avatar>
  <div class="font--sm ml-3">
    <div
      class="comment-body d-flex flex-col"
      [class]="isEditing ? 'background--light-shade' : 'background--light'"
    >
      <div class="d-flex items-center ion-justify-content-between">
        <span class="author text--xs text--bold">
          <ng-container *ngIf="author; else deletedUser">
            {{ author.full_name }}
          </ng-container>
          <ng-template #deletedUser>
            {{ "COMMON.LABELS.DELETED_USER" | translate }}
          </ng-template>
        </span>
        <ion-button
          class="more-actions-btn"
          fill="clear"
          size="small"
          (click)="optionsClick.emit({ id: id })"
          [attr.aria-label]="'COMMON.LABELS.OPTIONS' | translate"
          [title]="'COMMON.LABELS.OPTIONS' | translate"
        >
          <svg-icon
            class="ion-color-medium'"
            slot="icon-only"
            key="dots-three"
            aria-hidden="true"
          ></svg-icon>
        </ion-button>
      </div>
      <div
        class="content text--xs"
        [innerHTML]="body | linky | internalLinks"
      ></div>
    </div>
    <div class="mt-1 ml-2 color--medium text--xxs">
      <span>{{ createdAt | elapsedTime }}</span>
    </div>
  </div>
</ion-item>
